import { NavLink } from "react-router-dom";
import UserService from "../../services/UserService";

import "../../scss/NavBar.scss";

const ConnectNavItems = () => {
  return (
    <>
      <div
        className="nav-item p-2"
        data-te-nav-item-ref
        data-te-offcanvas-dismiss
      >
        <NavLink className="nav-link" to="/">
          Home
        </NavLink>
      </div>
      <div
        className="nav-item p-2"
        data-te-nav-item-ref
        data-te-offcanvas-dismiss
      >
        <NavLink className="nav-link" to="/accounts">
          View Accounts
        </NavLink>
      </div>
      <div
        className="nav-item p-2"
        data-te-nav-item-ref
        data-te-offcanvas-dismiss
      >
        <NavLink className="nav-link" to="/documents">
          Documents
        </NavLink>
      </div>
      {!UserService.isConnectiveComplete() &&
        <div
          className="nav-item p-2"
          data-te-nav-item-ref
          data-te-offcanvas-dismiss
        >
          <NavLink className="nav-link" to="/forms">
            Forms
          </NavLink>
        </div>
      }
      {!UserService.isConnectiveComplete() && !UserService.isRedQ() &&
        <div
          className="nav-item p-2"
          data-te-nav-item-ref
          data-te-offcanvas-dismiss
        >
          <NavLink className="nav-link" to="/benefits">
            Benefits
          </NavLink>
        </div>
      }
      <div
        className="nav-item p-2"
        data-te-nav-item-ref
        data-te-offcanvas-dismiss
      >
        <NavLink className="nav-link" to="/faqs">
          Help Centre
        </NavLink>
      </div>
      {UserService.hasRole('notification_admin') && <div
        className="nav-item p-2"
        data-te-nav-item-ref
        data-te-offcanvas-dismiss
      >
        <NavLink className="nav-link" to="/notifications">
          Notifications
        </NavLink>
      </div>}
      <div className="nav-item p-2 relative">
        <NavLink className="nav-link" to="/contact-us">
          Contact Us
        </NavLink>
      </div>
    </>
  );
};

const IntroducerNavItems = (props) => {
  return (
    <>
      {props?.userInfo?.preferred_username === 'stieg_larsson_test' || UserService.isAggregator() ?
        <div
          className="nav-item py-2 px-4 hub-link"
          data-te-nav-item-ref
          data-te-offcanvas-dismiss
        >
          <NavLink className="nav-link" to="/learning-hub">
            Learning Hub
          </NavLink>
        </div>
      : UserService.isCalculator() ? 
        <div
          className="nav-item p-2"
          data-te-nav-item-ref
          data-te-offcanvas-dismiss
        >
          <NavLink className="nav-link" to="/calculators">
            Calculators
          </NavLink>
        </div>
      :
        <>
          <div
            className="nav-item p-2"
            data-te-nav-item-ref
            data-te-offcanvas-dismiss
          >
            <NavLink className="nav-link" to="/applications">
              Applications
            </NavLink>
          </div>
          <div
            className="nav-item p-2"
            data-te-nav-item-ref
            data-te-offcanvas-dismiss
          >
            <NavLink className="nav-link" to="/portfolios">
              Portfolios
            </NavLink>
          </div>
          <div
            className="nav-item p-2"
            data-te-nav-item-ref
            data-te-offcanvas-dismiss
          >
            <NavLink className="nav-link" to="/scenarios">
              Scenarios
            </NavLink>
          </div>
          <div
            className="nav-item p-2"
            data-te-nav-item-ref
            data-te-offcanvas-dismiss
          >
            <NavLink className="nav-link" to="/calculators">
              Calculators
            </NavLink>
          </div>
          <div
            className="nav-item p-2"
            data-te-nav-item-ref
            data-te-offcanvas-dismiss
          >
            <NavLink className="nav-link" to="/resources">
              Resources
            </NavLink>
          </div>
          {UserService.canViewBrokerMap() &&
            <div
              className="nav-item p-2"
              data-te-nav-item-ref
              data-te-offcanvas-dismiss
            >
              <NavLink className="nav-link" to="/broker-map">
                Broker Map
              </NavLink>
            </div>
          }
          {!UserService.isConnectiveComplete() &&
            <>
              <div
                className="nav-item p-2"
                data-te-nav-item-ref
                data-te-offcanvas-dismiss
              >
                <NavLink className="nav-link" to="/benefits">
                  Benefits
                </NavLink>
              </div>
              <div
                className="nav-item py-2 px-4 hub-link"
                data-te-nav-item-ref
                data-te-offcanvas-dismiss
              >
                <NavLink className="nav-link" to="/learning-hub">
                  Learning Hub
                </NavLink>
              </div>
            </>
          }
        </>
      }
    </>
  );
};

const SolicitorNavItems = () => {
  return (
    <>
      <div
        className="nav-item p-2"
        data-te-nav-item-ref
        data-te-offcanvas-dismiss
      >
        <NavLink className="nav-link" to="/">
          New Loans
        </NavLink>

      </div>
      <div
        className="nav-item p-2"
        data-te-nav-item-ref
        data-te-offcanvas-dismiss
      >
        <NavLink className="nav-link" to="/discharges">
          Discharges
        </NavLink>

      </div>
    </>
  );
};

const RZNavItems = () => {
  return (
    <>
      {UserService.isClientServices() &&
        <div
          className="nav-item py-2 px-4"
          data-te-nav-item-ref
          data-te-offcanvas-dismiss
        >
          <NavLink className="nav-link dropdown-item" to="/manage-users">
            Manage Users
          </NavLink>
        </div>
      }
      {UserService._kc.realm.includes('Introducer_') &&
        <>
          <div
            className="nav-item p-2"
            data-te-nav-item-ref
            data-te-offcanvas-dismiss
          >
            <NavLink className="nav-link" to="/calculators">
              Calculators
            </NavLink>
          </div>
          <div
            className="nav-item p-2"
            data-te-nav-item-ref
            data-te-offcanvas-dismiss
          >
            <NavLink className="nav-link" to="/resources">
              Resources
            </NavLink>
          </div>
          {UserService.isBrokerAcademy() &&
            <div 
              className="nav-item p-2"
              data-te-nav-item-ref
              data-te-offcanvas-dismiss
            >
              <NavLink className="nav-link" to="/learning-hub">
                Learning Hub
              </NavLink>
            </div>
          }
        </>
      }
      {UserService.canEditTurnaround() &&
        <div 
          className="nav-item p-2"
          data-te-nav-item-ref
          data-te-offcanvas-dismiss
        >
          <NavLink className="nav-link" to="/edit-turnaround">
            Edit Turnaround
          </NavLink>
        </div>
      }
    </>
  );
};

export default function NavBarItems(props) {
  return (
    <div
      className="navbar-nav mr-auto flex flex-col pl-0 lg:flex-row"
      data-te-navbar-nav-ref
    >
      {UserService.isCustomer() && !UserService.isMigrated() ? ConnectNavItems() : null}
      {(UserService.isIntroducer() || UserService.isBDM()) && !UserService.isRedZed() ? IntroducerNavItems(props) : null}
      {UserService.isSolicitor() ? SolicitorNavItems(props) : null}
      {UserService.isRedZed() ? RZNavItems() : null}
    </div>
  );
}
